export default __webpack_public_path__ + "static/media/specialty.634aff82.png";